import React, { useEffect } from 'react';
import { useFloating, autoUpdate, offset, flip, shift, limitShift } from '@floating-ui/react';
import { useTranslation } from 'react-i18next';
import { Button } from '../ui/button';

// Premium-styled tooltip card. Auto-flips above/below the anchor based on viewport space.
// Click-outside does NOT close it — the tour controls advance/skip explicitly.
export default function TourTooltip({ targetEl, copyKey, onNext, onSkip, showSkip, gateType, isFinalStep }) {
  const { t } = useTranslation();

  const { refs, floatingStyles } = useFloating({
    placement: 'bottom',
    middleware: [offset(16), flip(), shift({ padding: 16, limiter: limitShift() })],
    whileElementsMounted: autoUpdate,
  });

  useEffect(() => {
    refs.setReference(targetEl || null);
  }, [targetEl, refs]);

  const title = t(`${copyKey}.title`, '');
  const body = t(`${copyKey}.body`, '');

  return (
    <div
      ref={refs.setFloating}
      style={{ ...floatingStyles, maxWidth: 'min(calc(100vw - 32px), 360px)', zIndex: 81 }}
      className="bg-gradient-to-br from-zinc-900 to-zinc-950 border border-zinc-800 rounded-2xl shadow-2xl p-4"
    >
      {title && <div className="text-base font-semibold text-white mb-1">{title}</div>}
      {body && <div className="text-sm text-zinc-300 mb-3 leading-relaxed">{body}</div>}
      <div className="flex items-center justify-between gap-3">
        {showSkip ? (
          <button
            onClick={onSkip}
            className="text-xs text-zinc-500 hover:text-zinc-300 underline"
          >
            {t('tour.common.skipThisTour')}
          </button>
        ) : <span />}
        {gateType === 'manual' ? (
          <Button
            onClick={onNext}
            className="bg-orange-500 hover:bg-orange-600 text-white px-4 py-2 rounded-lg text-sm"
          >
            {isFinalStep ? t('tour.common.done') : t('tour.common.next')}
          </Button>
        ) : (
          <span className="text-xs text-orange-400 italic">{t('tour.common.waitingForAction')}</span>
        )}
      </div>
    </div>
  );
}
